import { SellCosmeticError } from './constants';
const maxTwoPrecisionRegex = new RegExp(/^[-+]?[0-9]+(\.[0-9]{1,2})?$/);
export const formatErrorMessage = (error, currencyUnit, minPrice, maxPrice) => {
  switch (error) {
    case SellCosmeticError.NO_ERROR:
      return `Minimum ${roundPrice(minPrice)} ${currencyUnit}, Maximum ${roundPrice(maxPrice)} ${currencyUnit}`;

    case SellCosmeticError.MAX_AMOUNT_EXCEEDED:
      return `The maximum selling price is ${roundPrice(maxPrice)} ${currencyUnit}`;

    case SellCosmeticError.MIN_AMOUNT_EXCEEDED:
      return `The minimum selling price is ${roundPrice(minPrice)} ${currencyUnit}`;

    case SellCosmeticError.MAX_DECIMAL_EXCEEDED:
      return 'Only allows maximum 2 decimal numbers';

    default:
      return 'Sorry, something went wrong.';
  }
};

const roundPrice = price => price.toFixed(2);

export const validateInputPrice = ({
  price,
  maxPrice,
  minPrice
}) => {
  if (price > maxPrice) {
    return SellCosmeticError.MAX_AMOUNT_EXCEEDED;
  }

  if (price < minPrice) {
    return SellCosmeticError.MIN_AMOUNT_EXCEEDED;
  }

  if (!hasMaxTwoPrecision(price)) {
    return SellCosmeticError.MAX_DECIMAL_EXCEEDED;
  }

  return SellCosmeticError.NO_ERROR;
};
export const hasMaxTwoPrecision = price => maxTwoPrecisionRegex.test(price.toString());